var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5331 0.86128C12.5299 0.583736 11.4701 0.583736 10.4669 0.86128C9.86126 1.02882 9.3134 1.32484 8.70817 1.74026C8.11592 2.14678 7.42923 2.69614 6.55683 3.39406L6.53391 3.4124L4.53392 5.01239L4.44401 5.0843L4.444 5.08431C3.42727 5.89748 2.80148 6.39797 2.3445 7.02838C1.94023 7.58609 1.63945 8.21189 1.4565 8.87598C1.24971 9.62663 1.24982 10.428 1.24999 11.7299L1.25 11.845V17C1.25 20.1756 3.82436 22.75 7 22.75C8.51878 22.75 9.75 21.5188 9.75 20V15.9999C9.75 14.7573 10.7574 13.7499 12 13.7499C13.2426 13.7499 14.25 14.7573 14.25 15.9999V20C14.25 21.5188 15.4812 22.75 17 22.75C20.1756 22.75 22.75 20.1756 22.75 17V11.845L22.75 11.7299C22.7502 10.428 22.7503 9.62663 22.5435 8.87598C22.3605 8.21189 22.0598 7.58609 21.6555 7.02838C21.1985 6.39797 20.5727 5.89747 19.556 5.0843L19.4661 5.01239L17.4661 3.4124L17.4432 3.39407C16.5708 2.69615 15.8841 2.14678 15.2918 1.74026C14.6866 1.32484 14.1387 1.02882 13.5331 0.86128Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/home-filled.c2771800.svg";
export { ForwardRef as ReactComponent };